import type { ChangeVerb } from '@seen/core/queued-edits/model'
import { cn } from '@seen/ui'
import type { JSX } from 'react'
import { Tooltip } from '#src/components/core/tooltip/Tooltip.tsx'
import { TooltipContent } from '#src/components/core/tooltip/TooltipContent.tsx'
import { TooltipTrigger } from '#src/components/core/tooltip/TooltipTrigger.tsx'

const VERB_META: Record<
  ChangeVerb,
  { glyph: string; label: string; className: string }
> = {
  create: {
    glyph: '+',
    label: 'Create',
    className: 'text-pine-700 bg-pine-100',
  },
  update: {
    glyph: '~',
    label: 'Update',
    className: 'text-amber-700 bg-amber-100',
  },
  delete: { glyph: '-', label: 'Delete', className: 'text-red-700 bg-red-100' },
}

// Icon-only verb indicator: a +/~/- glyph at the left of the row, meaning
// surfaced via tooltip rather than text.
export function VerbGlyph({ verb }: { verb: ChangeVerb }): JSX.Element {
  const meta = VERB_META[verb]
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          role="img"
          aria-label={meta.label}
          className={cn(
            'flex size-4 shrink-0 items-center justify-center rounded font-bold font-mono text-xs leading-none',
            meta.className
          )}
        >
          {meta.glyph}
        </span>
      </TooltipTrigger>
      <TooltipContent>{meta.label}</TooltipContent>
    </Tooltip>
  )
}
